__turbopack_context__.v({
  "className": "pirata_one_faa4541b-module__ic8zxq__className",
});
